function checkWrapperValidity(wrapper) {
    if (!wrapper.querySelector("input[type='number']")) {
        throw new Error('Counter : given wrapper does not countain any input of type number');
    }
}

export class Counter {
    constructor(inputWrapper) {
        checkWrapperValidity(inputWrapper);
        this.wrapper = inputWrapper;

        this.input = this.wrapper.querySelector("input[type='number']");

        this.addControls();
        this.setInitialState();
        this.addListeners();
    }

    get value() {
        const value = this.input.value || 0;
        return parseInt(value, 10);
    }

    set value(newVal) {
        this.input.value = newVal;
        this.updateDecrementCtaState(this.value);

        const inputEvent = document.createEvent('Event');
        inputEvent.initEvent('input', true, true);

        this.input.dispatchEvent(inputEvent);
    }

    setInitialState() {
        if (this.input.value) {
            return;
        }

        this.input.value = 0;
        this.updateDecrementCtaState(this.value);
    }

    addControls() {
        if (!this.wrapper.querySelectorAll('button').length) {
            this.wrapper.insertAdjacentHTML('afterbegin', "<button type='button' data-decrement aria-hidden='true'></button>");
            this.wrapper.insertAdjacentHTML('beforeend', "<button type='button' data-increment aria-hidden='true'></button>");
        }

        this.incrementCta = this.wrapper.querySelector('[data-increment]');
        this.decrementCta = this.wrapper.querySelector('[data-decrement]');
    }

    addListeners() {
        this.incrementCta.addEventListener('click', (e) => this.increment(e));
        this.decrementCta.addEventListener('click', (e) => this.decrement(e));
        this.input.addEventListener('input', () => this.updateDecrementCtaState(this.value));
    }

    increment(e) {
        if (e.shiftKey) {
            this.value = this.value + 10;
            return;
        }

        this.value++;
    }

    decrement(e) {
        if (e.shiftKey) {
            this.value = this.value - 10;
            this.value = this.value < 0 ? 0 : this.value;
            return;
        }

        this.value--;
    }

    updateDecrementCtaState(value) {
        this.decrementCta.disabled = !value;
    }
}
